/**
 * <TutorWeekSummary> — ce que la semaine fait, au pied de la grille (molecule).
 *
 * Legacy `MaDispoEditor` → `WeekSummary` : combien d'heures portent déjà un live, combien le
 * tuteur en propose en plus, et ce que cela fait par semaine. Compté sur le brouillon
 * (`tutorWeekTotals`), il bouge sous le doigt. Sans aucun live, deux tuiles sur trois répéteraient
 * la troisième : il ne reste que les heures proposées.
 *
 * Les compteurs sont `<ReferralStatTile>` (le chiffre, ce qu'il compte dessous), dans une carte.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Card } from "../Card"
import { ReferralStatTile } from "../ReferralStatTile"
import { tutorWeekTotalLabels, tutorWeekTotals } from "../../../ports/primary/ui/formatters/tutorWeekFormatter"
import { type UITutorWeekDay } from "../../../ports/primary/ui/types/tutorDispoOffres"

export type TutorWeekSummaryProps = {
    days: UITutorWeekDay[]
    testID?: string
}

export function TutorWeekSummary(props: TutorWeekSummaryProps) {
    const { days, testID } = props
    const totals = tutorWeekTotals(days)
    const labels = tutorWeekTotalLabels(totals)

    const tiles = [
        ...(totals.live > 0 ? [{ key: "live", value: totals.live, label: labels.live }] : []),
        { key: "open", value: totals.open, label: labels.open },
        ...(totals.live > 0 ? [{ key: "total", value: totals.live + totals.open, label: labels.total }] : []),
    ]

    return (
        <Card p="4" testID={testID}>
            <View style={styles.row}>
                {tiles.map((tile) => (
                    <View key={tile.key} style={styles.cell}>
                        <ReferralStatTile value={String(tile.value)} label={tile.label} />
                    </View>
                ))}
            </View>
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: { flexDirection: "row", gap: theme.spacing["3"] },
    cell: { flex: 1, minWidth: 0 },
}))
